<div [formGroup]="form" class="flex flex-column gap-2">
  <label
    *ngIf="item.label && item.label !== ''"
    [attr.for]="item.key"
    class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <p-inputMask
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    styleClass="w-full"
    [mask]="item.config?.mask"
    [placeholder]="item.placeholder || '' | translate"
    [formControlName]="item.key"
    [maxlength]="item.config?.maxLength"
    [slotChar]="item.config?.slotChar || ' '"
  ></p-inputMask>

  <ng-container *ngFor="let error of item.errorMessage | keyvalue">
    <small
      class="p-error block font-italic"
      *ngIf="isInValid && hasError(error.key)"
    >
      {{ error.value?.message || '' | translate : error.value?.params }}
    </small>
  </ng-container>
</div>
